import { useLanguage } from "../i18n/LanguageContext";
import { Reveal } from "../components/Reveal";

const content = {
  en: {
    overline: "About Sawtly",
    title: "Built between Khartoum and Riyadh",
    sections: [
      { h: "Why we exist", p: "Sawtly started with a simple observation: Gulf businesses lose a fortune to unanswered phones, and the AI tools built to fix it were never built for the Gulf. They spoke the wrong Arabic, kept the wrong hours, and asked owners to change how they work. We built the opposite." },
      { h: "The founder story", p: "Our founder grew up between Sudan and Saudi Arabia — switching between dialects the way Gulf callers switch between Arabic and English mid-sentence. Years of watching family businesses in Riyadh lose bookings to busy phone lines turned into a conviction: the phone is still the highest-intent channel in the Gulf, and it deserves first-class technology." },
      { h: "The Sudanese connection", p: "Sawtly's engineering roots run through the Sudanese tech diaspora — a community that knows what it means to build world-class products for underserved markets. That perspective is why dialect accuracy, fair pricing, and WhatsApp-first workflows are not features for us; they are the foundation." },
      { h: "Our mission", p: "Make every Gulf business answerable. From a single-chair salon in Jeddah to a clinic group in Dubai, every call should be picked up on the first ring, in the caller's dialect, at any hour. We only earn when we recover revenue for you — that's the deal." },
    ],
  },
  ar: {
    overline: "عن صوتلي",
    title: "بُني بين الخرطوم والرياض",
    sections: [
      { h: "ليش نحن موجودين", p: "صوتلي بدأ بملاحظة بسيطة: الأعمال الخليجية تخسر ثروة بسبب جوالات ما عليها رد، وأدوات الذكاء الاصطناعي اللي المفروض تصلح هذا ما بُنيت للخليج أصلاً. تتكلم عربي غلط، وتشتغل بساعات غلط، وتطلب من الملاك يغيرون طريقة شغلهم. احنا بنينا العكس." },
      { h: "قصة المؤسس", p: "مؤسسنا تربّى بين السودان والسعودية — يبدّل بين اللهجات بنفس طريقة المتصلين الخليجيين اللي يبدلون بين العربي والإنجليزي بنص الجملة. سنين من مشاهدة أعمال العائلة في الرياض تخسر حجوزات بسبب خطوط مشغولة تحولت لقناعة: الجوال ما زال أعلى قناة نية في الخليج، ويستاهل تقنية من الطراز الأول." },
      { h: "العلاقة السودانية", p: "جذور صوتلي الهندسية تمتد عبر الجالية التقنية السودانية — مجتمع يعرف وش يعني تبني منتجات عالمية لأسواق مهملة. هذي النظرة هي ليش دقة اللهجة والتسعير العادل وسير العمل المبني على واتساب مو مميزات عندنا؛ هي الأساس." },
      { h: "مهمتنا", p: "نجعل كل عمل خليجي قابل للرد. من صالون بكرسي واحد في جدة لمجموعة عيادات في دبي، كل مكالمة يُرد عليها من أول رنة، بلهجة المتصل، في أي ساعة. نكسب فقط لما نسترجع إيرادًا لك — هذه الصفقة." },
    ],
  },
};

const About = () => {
  const { lang } = useLanguage();
  const c = content[lang];
  return (
    <main data-testid="about-page" className="mx-auto max-w-4xl px-6 pb-24 pt-36 lg:px-10 lg:pt-44">
      <Reveal>
        <p className="overline-tag">{c.overline}</p>
        <h1 className="mt-4 font-display text-4xl font-extrabold md:text-6xl">{c.title}</h1>
      </Reveal>
      <div className="mt-16 flex flex-col gap-14">
        {c.sections.map((s, i) => (
          <Reveal key={i} delay={i * 0.08}>
            <div className="border-s-2 border-gold/40 ps-8" data-testid={`about-section-${i}`}>
              <h2 className="font-display text-2xl font-bold md:text-3xl">{s.h}</h2>
              <p className="mt-4 text-base leading-relaxed text-zinc-400 md:text-lg">{s.p}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </main>
  );
};

export default About;
